module.exports = __webpack_public_path__ + "img/hyper.9459f164.svg";